import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/features/home/HomePage";
import { homeQuery } from "@/lib/api/queries";
import { DEFAULT_ENV } from "@/lib/search";

export const Route = createFileRoute("/w/$workspace/p/$project/")({
  loaderDeps: ({ search }) => ({ env: search.env ?? DEFAULT_ENV }),
  loader: ({ context, params, deps }) =>
    context.queryClient.ensureQueryData(homeQuery(params.workspace, params.project, deps.env)),
  component: () => {
    const { workspace, project } = Route.useParams();
    const { env } = Route.useLoaderDeps();
    return <HomePage workspace={workspace} project={project} env={env} />;
  },
});
